import { setSpecificMessage, size } from "valibot";
setSpecificMessage(
  size,
  (issue) => `Taille invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);